<template>
	<div class="user-reports">
		<AppCard :title="getString('report')" :button-text="getString('generate')" :button-loading="loadingReport" @button-click="downloadReport">
			<template #body>
				<div class="user-reports-body">
					<AppList :items="reportsItems" />
					<div class="download-report" v-if="reportLink">
						<p>{{ getString("report_ready") }}</p>
						<a :href="reportLink" target="_blank" :download="reportLinkName">{{ getString("download") }}</a>
					</div>
				</div>
			</template>
		</AppCard>
		<AppNotification :title="getString('error')" :body-text="getString('try_later_error')" :type="-2" ref="reports-fail" />
	</div>
</template>

<script>
import AppCard from "@/shared/components/AppCard.vue";
import {useLanguageStore, useNotificationStore} from "@/shared/stores";
import AppList from "@/shared/components/AppList.vue";
import API from "@/shared/helpers/API";
import {formatDateTime} from "@/shared/helpers/dates";
import AppNotification from "@/shared/components/AppNotification.vue";

export default {
	setup() {
		const languageStore = useLanguageStore();
		const notificationStore = useNotificationStore();
		return {getString: languageStore.getString, notificationStore};
	},
	name: "UserReports",
	components: {AppNotification, AppList, AppCard},
	props: {
		businesses: {
			type: Array,
			default: () => []
		},
		periodDates: {
			type: Object,
			default: null
		},
	},
	data() {
		return {
			selectedReport: 0,
			reportLink: null,
			loadingReport: false,
		}
	},
	computed: {
		reportsItems() {
			return [
				{title: this.getString('report'), selectValues: [this.getString('products'), this.getString('stations')], selectedIndex: this.selectedReport, callbackSelect: (index) => {this.selectedReport = index;}},
			]
		},
		selectedBusinessesIds() {
			if(!this.businesses || !this.businesses.length) { return []; }
			return this.businesses.map(business => {
				if(business && business.business_id) {
					return business.business_id;
				}
			});
		},
		reportLinkName() {

			if(this.reportLink) {
				let linkParts = this.reportLink.split("/");
				let lastPart = linkParts.length > 0 ? linkParts[linkParts.length - 1] : this.reportLink;
				let nameParts = lastPart.split(".");
				if(nameParts.length > 1) {
					nameParts.pop();
				}
				return nameParts.join(".");
			} else {
				return "";
			}

		}
	},
	methods: {
		downloadReport() {

			let endDateDB = formatDateTime(this.periodDates.end);
			let startDateDB = formatDateTime(this.periodDates.start);

			this.reportLink = null;
			this.loadingReport = true;
			API.init().superDownloadReport(startDateDB, endDateDB, this.selectedBusinessesIds, this.selectedReport, (r) => {
				this.loadingReport = false;
				if(r && r.result && r.result === "OK") {
					this.reportLink = r.link;
				} else {
					console.log("Error downloading report", r);
					this.$refs["reports-fail"].openNotification();
				}
			});
		}
	}
}
</script>

<style scoped lang="scss">
.user-reports {
	:deep(.card-body) {
		padding: 0 !important;
	}

	.download-report {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 8px 12px;
	}
}
</style>